import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid } from '@mui/material';
import React from 'react';
import {
  Item,
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypoVariants,
  WsTypography,
} from 'wisestep-base';

interface BulkTagModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  title: string;
  description: string;
  confirmText?: string;
  dismissText?: string;
  icon?: React.ReactNode;
}

const BulkTagModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  title,
  description,
  confirmText = 'Confirm',
  dismissText = 'Dismiss',
  icon,
}: BulkTagModalProps) => {
  return (
    <WsDialog openDialog={open} onClose={onClose} size={WsDialogSize.SMALL}>
      <>
        <CloseIcon
          sx={{
            cursor: 'pointer',
            ml: '94%',
            mt: '1%',
            color: WsColors.TheBlues500,
          }}
          fontSize="small"
          onClick={onClose}
        />
        <Item sx={{ pt: 0 }}>
          <Grid container direction="row" spacing={1} alignItems="center">
            {icon && <Grid item>{icon}</Grid>}
            <Grid item>
              <WsTypography variant={WsTypoVariants.TITLE} bold>
                {title}
              </WsTypography>
            </Grid>
          </Grid>
          <WsTypography>{description}</WsTypography>
          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <WsButton variant="outlined" onClick={onClose} disabled={loading}>
              {dismissText}
            </WsButton>
            <WsButton onClick={onConfirm} disabled={loading}>
              {confirmText}
            </WsButton>
          </Box>
        </Item>
      </>
    </WsDialog>
  );
};

export default BulkTagModal;
